export default {
  path: '/ingredient',
  component: () => import('@/views/ingredient/Ingredient.vue'),
  children: [
    {
      path: '',
      name: 'IngredientList',
      component: () => import('@/views/ingredient/pages/IngredientList.vue'),
      meta: {
        name: 'navigationDrawer.ingredient',
        icon: '/icons/pill.svg',
        auth: true
      }
    },
    {
      path: 'create',
      name: 'IngredientCreate',
      component: () => import('@/views/ingredient/pages/IngredientCreate.vue'),
      meta: {
        name: 'navigationDrawer.ingredient',
        icon: '/icons/pill.svg',
        auth: true
      }
    },
    {
      path: 'detail/:id',
      name: 'IngredientDetail',
      component: () => import('@/views/ingredient/pages/IngredientDetail.vue'),
      meta: {
        name: 'navigationDrawer.ingredient',
        icon: '/icons/pill.svg',
        auth: true
      }
    },
    {
      path: 'edit/:id',
      name: 'IngredientEdit',
      component: () => import('@/views/ingredient/pages/IngredientEdit.vue'),
      meta: {
        name: 'navigationDrawer.ingredient',
        icon: '/icons/pill.svg',
        auth: true
      }
    },
    {
      path: 'print-ingredient',
      name: 'PrintIngredient',
      component: () => import('@/views/ingredient/components/PrintIngredient.vue'),
      meta: {
        auth: true,
        layout: 'blank'
      }
    }

  ]
}
